import React from "react";
import { Clock } from "lucide-react";

const InsurancePage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-black-dark-main px-6">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <Clock size={80} className="text-primary1 animate-pulse" />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Insurance Services
        </h1>

        <p className="text-gray-300 text-lg md:text-xl max-w-xl mx-auto">
          Our insurance solutions are currently being prepared to offer you the
          best protection for your financial future.
        </p>

        <p className="text-primary1 text-xl font-semibold mt-6">Coming Soon!</p>

        <a
          href="/"
          className="mt-8 inline-block px-6 py-3 bg-primary1 text-white rounded-xl shadow-lg hover:bg-primary-300 transition"
        >
          Go Back Home
        </a>
      </div>
    </div>
  );
};

export default InsurancePage;
